import Head from 'next/head';

import Custom404Page from 'components/404';

import { toAbsoluteLink } from 'lib/links';

import LINKS from 'constants/links';

const Custom404 = () => (
  <>
    <Head>
      <link href={toAbsoluteLink(LINKS[404])} rel="canonical" />
    </Head>
    <Custom404Page />
  </>
);

export default Custom404;
